import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BusquedaGlobalPage } from '../app/busqueda-global/busqueda-global.page'
import { CargarMedicosPage } from '../app/cargar-medicos/cargar-medicos.page'
import { OpcionesHcPoppoverPage } from '../app/opciones-hc-poppover/opciones-hc-poppover.page'
import { CrearNotasEnfermeriaPage } from '../app/crear-notas-enfermeria/crear-notas-enfermeria.page'
import { DetalleFormatoPage } from '../app/detalle-formato/detalle-formato.page'
import { FormsModule } from '@angular/forms';  
import { GeneralServices } from '../services/generalServices';  
//import { Camera } from '@ionic-native/camera';

//import { BarcodeScanner } from '@ionic-native/barcode-scanner';
//import { AndroidPermissions } from '@ionic-native/android-permissions';


import { InjectableRxStompConfig, RxStompService, rxStompServiceFactory } from '@stomp/ng2-stompjs';

import { myRxStompConfig } from './my-rx-stomp.config';
import { Zoom } from '@ionic-native/zoom/ngx';

import { IonicSignaturePadModule,IonicsignaturepadProvider } from 'ionicsignaturepad';
import { FormatoGenericoPage } from '../app/formato-generico/formato-generico.page';
import { ListarFormatosGenericosPage } from '../app/listar-formatos-genericos/listar-formatos-genericos.page';
import { ZeusConferenceService } from './conference-component/zeus-conference.service';
import { AccetOrDeclineCallComponent } from './conference-component/accet-or-decline-call/accet-or-decline-call.component';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';



@NgModule({
  declarations: [AccetOrDeclineCallComponent,AppComponent, BusquedaGlobalPage, OpcionesHcPoppoverPage, CrearNotasEnfermeriaPage,DetalleFormatoPage, CargarMedicosPage, FormatoGenericoPage, ListarFormatosGenericosPage],
  entryComponents: [AccetOrDeclineCallComponent, BusquedaGlobalPage, OpcionesHcPoppoverPage, CrearNotasEnfermeriaPage,DetalleFormatoPage, CargarMedicosPage, FormatoGenericoPage, ListarFormatosGenericosPage],
  imports: [BrowserModule,FormsModule, IonicModule.forRoot(), 
    IonicSignaturePadModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),

    AppRoutingModule],
  providers: [
    StatusBar,
    Zoom,
    
    BarcodeScanner,
    ZeusConferenceService,
    SplashScreen,
    IonicsignaturepadProvider,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GeneralServices,
      multi: true
    },
    {
      provide: InjectableRxStompConfig,
      useValue: myRxStompConfig
    },
    {
      provide: RxStompService,
      useFactory: rxStompServiceFactory,
      deps: [InjectableRxStompConfig]
    }
  //  BarcodeScanner,
  // Camera,
  //  AndroidPermissions,
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class AppModule {}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}